import { useState } from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { SetPortalPreferencesAPI } from '../services/index.js';
import { SetUserPreferences } from '../redux/actions/user.js';
import { ReactSelectOptions, Toastify } from '../components/utils/index.js';
import { LanguageLoader } from '../assets/languages/index.js';
import FieldContainer from '../components/features/FieldContainer.jsx';
import md5 from 'md5';

const Profile = () =>
{
	const user = useSelector((state) => state.current_user);
	const settings = useSelector((state) => state.settings);
	const preferences = useSelector((state) => state.preferences);	
	const [theme, SetTheme] = useState({value: preferences.theme, label: settings.dropdowns['themes'][preferences.theme]});
	const [lang, SetLanguage] = useState({value: preferences.language, label: settings.dropdowns['languages'][preferences.language]});
	const [currentPassword, SetCurrentPassword] = useState('');
	const [newPassword, SetNewPassword] = useState('');
	const [confirmPassword, SetConfirmPassword] = useState('');
	const dispatch = useDispatch();
	const themes = ReactSelectOptions(settings.dropdowns.themes);
	const languages = ReactSelectOptions(settings.dropdowns.languages);
	const language = LanguageLoader(preferences.language);

	const SavePreferences = async () =>
	{
		try
		{
			const data = {
				"theme" : theme.value,
				"language": lang.value,
				"current_password": currentPassword !== '' ? md5(currentPassword): '',
				"new_password": newPassword !== '' ? md5(newPassword) : '',
				"confirm_password": confirmPassword !== '' ? md5(confirmPassword) : '',
			};
			if(newPassword !== confirmPassword)
			{
				Toastify(language.PROFILE.EQUAL_PASSWORD);
			}
			else
			{
				const APIResponse = await SetPortalPreferencesAPI(data);
				if(Object.keys(APIResponse).length)
				{
					localStorage.setItem("theme", APIResponse.theme);
					localStorage.setItem("language", APIResponse.language);
					if(APIResponse.token)
					{
						localStorage.setItem("token", APIResponse.token);
					}
					dispatch(SetUserPreferences(APIResponse)).then(() => window.location.replace('/Profile'));
				}
			}
		} catch(ex){}
	}

	return(
		<>
		<div className="wrapper flex flex-wrap flex-col">
			<div className='title'>
				<h6>{language["CONFIG"]}</h6>
				<button className='btn-primary' onClick={SavePreferences} type="button">{language["SAVE"]}</button>
			</div>
			<form className='flex flex-wrap'>
				<FieldContainer label={language["PROFILE"]["THEME"]}>
					<Select
						options={themes}
						defaultValue={themes[0]}
						value={theme}
						onChange={(data) => {SetTheme(data);}}
						isClearable={false}
						menuPlacement="auto"
						className={settings.strings.dropdown_container}
						classNamePrefix={settings.strings.dropdown_prefix}
					/>
				</FieldContainer>
				<FieldContainer label={language["PROFILE"]["LANGUAGE"]}>
					<Select
						options={languages}
						defaultValue={languages[0]}
						value={lang}
						onChange={(data) => {SetLanguage(data);}}
						isClearable={false}
						menuPlacement="auto"
						className={settings.strings.dropdown_container}
						classNamePrefix={settings.strings.dropdown_prefix}
					/>
				</FieldContainer>
			</form>
			{settings.password_changing ? <>
			<div className='title !border-0 !mb-0 !mt-3'>
				<h6>{language["PROFILE"]["SECURITY_SETTINGS"]}</h6>
			</div>
			<form className='flex flex-wrap'>
				<FieldContainer label={language["PROFILE"]["CURRENT_PASSWORD"]}>
					<input type='password' onChange={(e) => SetCurrentPassword(e.target.value)}/>
				</FieldContainer>
				<FieldContainer label={language["PROFILE"]["NEW_PASSWORD"]}>
					<input type='password' onChange={(e) => SetNewPassword(e.target.value)}/>
				</FieldContainer>
				<FieldContainer label={language["PROFILE"]["CONFIRM_PASSWORD"]}>
					<input type='password' onChange={(e) => SetConfirmPassword(e.target.value)}/>
				</FieldContainer>
			</form>
			</> : null}
		</div>
		<div className="wrapper flex flex-wrap">
			<div className='title'>
				<h6>{language["USER_INFORMATION"]}</h6>
			</div>
			<FieldContainer label={language["PROFILE"]["NAME"]}>
				<div className='value'>{user.full_name}</div>
			</FieldContainer>
			<FieldContainer label={language["PROFILE"]["USERNAME"]}>
				<div className='value'>{user.username}</div>
			</FieldContainer>
			<FieldContainer label={language["PROFILE"]["PHONE"]}>
				<div className='value'>{user.phone_mobile}</div>
			</FieldContainer>
			<FieldContainer label={language["PROFILE"]["EMAIL"]}>
				<div className='value'>{user.email}</div>
			</FieldContainer>
			<FieldContainer label={language["PROFILE"]["USER_TYPE"]}>
				<div className='value'>{user.is_partner === 1 || user.is_partner === '1' ? language["PROFILE"]["PARTNER"] : language["PROFILE"]["CUSTOMER"]}</div>
			</FieldContainer>
			<FieldContainer label={language["PROFILE"]["ACCOUNT"]}>
				<div className='value'>{user.account.name}</div>
			</FieldContainer>
			{user.is_partner === 1 || user.is_partner === '1' ? 
			<FieldContainer label={language["PROFILE"]["PARTNER"]}>
				<div className='value'>{user.partner_name}</div>
			</FieldContainer>
			: null}
		</div>
		</>
	)
}

export default Profile;